module.exports = __webpack_public_path__ + "img/Genericsvg.1e82acd9.svg";